import { __extends } from '../../node_modules/tslib/tslib.es6.js';
import { Slotify } from '../../node_modules/@eightshapes/slotify/src/slotify.js';
import { PvdBaseComponent } from './pvd-base-component.js';
import { debounce } from '../pvd-utils/scripts/debounce.js';

var SLOT_CHANGE_DELAY = 25;
var PvdSlotifyBaseComponent = /** @class */ (function (_super) {
    __extends(PvdSlotifyBaseComponent, _super);
    function PvdSlotifyBaseComponent() {
        var _this = _super.call(this) || this;
        // Trigger LitElement lifecycles when slots are updated
        var slotchangeHandler = function () {
            if (_this.isConnected) {
                _this.requestUpdate();
            }
        };
        _this.addEventListener('slotchange', debounce(slotchangeHandler, SLOT_CHANGE_DELAY));
        return _this;
    }
    PvdSlotifyBaseComponent.prototype.hasSlotableContent = function (slotName) {
        if (slotName === void 0) { slotName = 'default'; }
        return _super.prototype.hasSlotableContent.call(this, slotName, {
            ignoreComments: true,
            ignoreWhitespace: true,
        });
    };
    PvdSlotifyBaseComponent.prototype.isSlotUsed = function (slotName) {
        if (slotName === void 0) { slotName = 'default'; }
        return this.hasSlotableContent(slotName) || this.hasAssignedSlotContent(slotName);
    };
    return PvdSlotifyBaseComponent;
}(Slotify(PvdBaseComponent)));

export { PvdSlotifyBaseComponent, SLOT_CHANGE_DELAY };
